import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-2 shadow-md rounded text-sm">
        <p className="font-semibold text-black">{payload[0].value}</p>
      </div>
    );
  }
  return null;
};

const LineChartComponent = ({ selectedRange, chartData, dataKey }) => {
  const chartFilterData =
    selectedRange === "This Week"
      ? chartData?.this_week || []
      : chartData?.monthly || [];
  const xAxisKey = selectedRange === "This Week" ? "day" : "month";

  // Check if all values in "this_week" are 0
  const isDataEmpty =
    selectedRange === "This Week" &&
    chartFilterData.every(
      (item) =>
        item.consumers_registered === 0 && item.providers_registered === 0
    );

  return (
    <div className="w-full p-4 bg-white shadow-md rounded-lg">
      {isDataEmpty ? (
        <p className="text-center text-[#1C2024]">
          Data Not Found
        </p>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartFilterData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={xAxisKey} />
            <YAxis tickFormatter={(value) => Math.floor(value)} />
            <Tooltip content={<CustomTooltip />} />
            <Legend className="mt-4" />
            <Line
              type="monotone"
              dataKey={dataKey}
              stroke="#8884d8"
              strokeWidth={2}
              className="mt-5"
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default LineChartComponent;
